import './App.css';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Header from './components/Header';
import Main from './pages/Main';
import Survey from './pages/Survey';
import Success from './pages/Success'; // Import the Success component
import Preloader from './components/Preloader';

function App() {
  return (
    <Router>
      <div>
        <Header />
        <Routes>
          <Route path="/success" element={<Success />} />
          {/* <Route path="/success" element={<Success />} /> */}
          <Route path="/" element={<Survey />} />
          <Route path="/p" element={<Preloader/>} />
        </Routes>
      </div>
    </Router>
  );
}

export default App;
